import { format } from 'date-fns'
import type React from 'react'
import styled from 'styled-components'

import Pill from '@/components/Pill'
import type { CompanyCCJ as CompanyCCJT } from '@/types/Activity'

interface Props {
  ccj: CompanyCCJT
}

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  align-items: center;
`

const CompanyCCJ: React.FC<Props> = ({ ccj }) => {
  return (
    <Container>
      <p>{format(new Date(ccj.courtDate), 'dd/MM/yyyy')}</p>
      <p>£{ccj.amount}</p>
      <Pill type={ccj.state === 'Active' ? 'negative' : 'caution'}>{ccj.state}</Pill>
    </Container>
  )
}

export default CompanyCCJ
